import React, { useContext, useEffect, useState, useRef } from 'react'
import './Dashboard.css'
import { motion } from 'framer-motion';
import Tangelo from "../../imgs/milkcan.png";
import Next from "../../imgs/next.png";
import Dashcontendts from '../Dashcontents/Dashcontendts';
import Sidebar from '../Sidebar/Sidebar';
import Globalcontext from '../../Context/Globalcontext';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { SingleBed } from '@mui/icons-material';
import Treport from '../Treport/Treport';
import { useTranslation } from "react-i18next";

let randomNumber = "0";

const Dashboard = (props) => {

  const { t } = useTranslation();

  const reflogout = useRef(null);
  const refdeleteclose = useRef(null);

  const navigate = useNavigate();
  const notify = (msg) => toast(msg);
  const [kendraValue, setKendraValue] = useState(localStorage.getItem('kendra') + "," + localStorage.getItem('city'));
  const { submenu, setsubmenu, newcustsource, setNewcustsource, kendrasource, setKendrasource, headname, setHeadname } = useContext(Globalcontext);

  const handledeleteclose = () => {
    refdeleteclose.current.click();
  }

  const opennewkendra = () => {
    refdeleteclose.current.click();
  }

  const handlelogout = () => {
    reflogout.current.click();
  }

  useEffect(() => {
    randomNumber = Math.random();
  })

  const openkendra = () => {
    navigate("/Dashboard");
    setsubmenu("kendra");
    setNewcustsource("kendra");
    setKendrasource("Dashboard");
  }

  const logout = (contact) => {

    localStorage.setItem("status", "");
    localStorage.setItem("contact", "");
    localStorage.setItem("contactplant", "");
    localStorage.setItem("kendra", "Not available");
    localStorage.setItem("kmobno", "");
    localStorage.setItem("ksr", "");
    localStorage.setItem("status", "");
    localStorage.setItem("vdate", "");

    localStorage.setItem("name", "");
    localStorage.setItem("city", "");
    localStorage.setItem("tal", "");
    localStorage.setItem("dist", "");
    localStorage.setItem("username", "");
    localStorage.setItem("mobile", "");
    localStorage.setItem("status", "");
    localStorage.setItem("vdate", "");
    localStorage.setItem("bill10type", "");
    localStorage.setItem("plant", "");
    localStorage.setItem("parent", "");
    localStorage.setItem("suchana", "");
    localStorage.setItem("thevper", "");
    localStorage.setItem("dur", "");
    localStorage.setItem("digri", "");

    localStorage.setItem("lastbilldate", "Not available");
    localStorage.setItem("custlist", "");
    localStorage.setItem("mhrates", "");
    localStorage.setItem("gayrates", "");
    localStorage.setItem("treport", "");
    localStorage.setItem("mhrates9", "");
    localStorage.setItem("gayrates9", "");
    localStorage.setItem("sanghlist", "");
    localStorage.setItem("lpoints", "");

    localStorage.setItem("thevregular", "");
    localStorage.setItem("thev1", "");
    localStorage.setItem("thev2", "");
    localStorage.setItem("thev3", "");
    localStorage.setItem("advchalu", "");
    localStorage.setItem("advkapat", "");
    localStorage.setItem("khchalu", "");
    localStorage.setItem("khkapat", "");
    localStorage.setItem("ratibchalu", "");
    localStorage.setItem("ratibkapat", "");
    localStorage.setItem("hptachalu", "");
    localStorage.setItem("intrchalu", "");
    localStorage.setItem("sanghkchalu", "");
    localStorage.setItem("sanghkkapat", "");
    localStorage.setItem("retanchalu", "");
    localStorage.setItem("retankapat", "");
    localStorage.setItem("kapat1", "");
    localStorage.setItem("kapat2", "");
    localStorage.setItem("kapat3", "");
    localStorage.setItem("vahtuk", "");
    localStorage.setItem("comm", "");
    localStorage.setItem("ada", "");
    localStorage.setItem("billamt", "");

    refdeleteclose.current.click();
    props.setProgress(50);
    setTimeout(() => {
      props.setProgress(100);
    }, 200);

    navigate("/");
    notify(t("Dashboard.toast.loggedOut"));
  }

  const bodycontainerVariants = {
    true: {
      marginLeft: '0px',
      width: '-webkit-calc(100vw - 14rem)'
    },
    false: {
      marginLeft: '-130px',
      width: '-webkit-calc(100vw - 6rem)',
      transition: {
        delay: 0.6
      }
    }
  }

  return (

    <div>

      <button
        type="button"
        className="btn btn-primary"
        data-bs-toggle="modal"
        hidden="{true}"
        ref={reflogout}
        data-bs-target="#exampleModaldelete"
      >
      </button>

      <div className="modal fade" id="exampleModaldelete" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel"></h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" ref={refdeleteclose} aria-label="Close">
              </button>
            </div>
            <div className="modal-body">
              <h4 className="modal-title" id="exampleModalLabel">
                {t("Dashboard.modal.closeSoftwareTitle")}
              </h4>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={handledeleteclose}  >
                {t("Dashboard.buttons.no")}
              </button>
              <button type="button" className="btn btn-danger" onClick={logout}>
                {t("Dashboard.buttons.yes")}
              </button>
            </div>
          </div>
        </div>
      </div>

      <motion.div
        initial={`${props.open}`}
        animate={`${props.open}`}
        variants={bodycontainerVariants}
        className="body_container">

        <motion.div
          className="body">
          <div className="profileinfo">
            <div className="firstpart2">
              <img className='imglogo' src={Tangelo} alt="" />
              <span>{kendraValue}</span>
              <img onClick={openkendra} className='next' src={Next} alt="" />
            </div>
            <div className="secondpart">
              <Treport rand={randomNumber} />
              <span className='headnamee'>{headname}/</span>
              <button onClick={handlelogout} className='signout'>
                {t("Dashboard.buttons.logout")}
              </button>
            </div>
          </div>

          <Dashcontendts setKendraValue={setKendraValue} logout={logout} setProgress={props.setProgress} />
        </motion.div>

      </motion.div>
      <ToastContainer />
    </div>
  )
}

export default Dashboard
